import axios from 'axios'
import { Poppins, Quicksand } from 'next/font/google'
import React, { useState } from 'react'
import { IoMdClose } from 'react-icons/io'
const popins = Poppins({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
const quickSand = Quicksand({weight:['400','500','600','700'],subsets:['latin'],display:'swap',preload:true})
export default function JobSupportForm({hideHeader,placement,job,closeBtn,closeForm,title}) {
const [loading,setLoading]=useState(false);
const [formData,setFormData]=useState({
    name:"",
    email:"",
    mobileNumber:"",
    message:"",
    job:job,
    placement:placement
})



const handleOnChange = (e)=>{
    const {name,value} = e.target
    setFormData({...formData,[name]:value});
}
const handleSubmit = async(e)=>{
e.preventDefault();


setLoading(true);
try {
   const response = await axios.post(`${process.env.url}/api/jobSupport`,formData)
   console.log("Form Data:",response.data);
       // Reset form
       setFormData({
        name: "",
        email: "",
        mobileNumber: "",
        message:"",
      });
    
} catch (error) {
    console.error('Client-side error:', error); // Log any client-side error
    alert('An error occurred while registering. Please Call This Number: +91 7825888899 ');  
}
finally{
    setLoading(false);
}
}
  return (
 <>


 <div className='form-box'>
 
    <form className={`mt12 form-inputs`} onSubmit={handleSubmit}>
        <div className='df fjsb'>
    <p className={`fs-18 tfs-16 mfs-14 tac pdb20 fwb500 ${popins.className}`}>{title}</p> 
    {closeBtn && (
        <div className={`cursor`} onClick={closeForm}>
        <IoMdClose size={24} color='#000 '/>
        </div>
        )}
        </div>
        <input type='text' name='name'  className={`fs-16 fwb400 enroll-input ${quickSand.className}`}
       value={formData.name} onChange={handleOnChange}
       required placeholder="Full Name" autoComplete='name'/>
        <input type='email' name='email' className={`fs-16 mt14 fwb400 enroll-input ${quickSand.className}`}
          value={formData.email} onChange={handleOnChange}
       required placeholder="Email" autoComplete='email'/>
        <input type='number' name='mobileNumber' className={`fs-16 mt14 fwb400 enroll-input ${quickSand.className}`}
        value={formData.mobileNumber} onChange={handleOnChange}
       required placeholder="Mobile Number" autoComplete='tel'/>
       {job && <input type='text' name='job' className={`fs-16 mt14 fwb700 enroll-input ${quickSand.className}`}
        value={`Job Support : ${formData.job || '' } `} onChange={handleOnChange}
        readOnly autoComplete='off'/>}
    {placement &&  <input type='text' name='placement' className={`fs-16 mt14 fwb700 enroll-input ${quickSand.className}`}
        value={`Placement : ${formData.placement || '' } `} onChange={handleOnChange}
        readOnly autoComplete='placement'/>
    }
        <textarea name='message' className='fs-16 mt14 fwb400 enroll-input' style={{height:'100px'}} 
          value={formData.message} onChange={handleOnChange}
        placeholder={`${hideHeader ? 'Message' :'Describe Your Training Needs'}`}
        autoComplete='message'/>
      {/* <div className="df gap8">
              <input type="checkbox" id="terms" name="terms" className="checkbox" />
              <label htmlFor="terms" className="fs-14">
              By providing your contact details, You agree to our
              <Link legacyBehavior href="/terms">
              <a target="_blank" aria-label="Terms of use and privacy policy page">
                    Terms of use & Privacy policy
                  </a>
                </Link>
              </label>
            </div> */}
         <button className={`fs-16 fwb600 mt24 enroll-form-btn cw cursor ${popins.className}`}>
         {loading ? (
          <div className="spinner-container">
            <div className="spinner"></div>
          </div>) : "Enroll Now"}
          </button>   

    </form>

 </div>

 <style jsx>
    {`
    .robot-box{
    width: auto;
    height: 78px;

    }
      .recaptcha-box {
                    margin-top: 16px;
                    display: flex;
                    justify-content: center;
                }
    .form-box{
    box-shadow: 0px 4px 16px 0px #00000040;
    width: 505px;
    border-radius:10px;
    height: 100%;
    }
    .form-head{
    background: #000;
    padding: 10px;
      border-radius:10px 10px 0px 0px;
    }
    .form-inputs{

   padding: 15px 29px 15px 16px;

    }
    .enroll-input{
     border-radius: 10px;
     width: 100%;
     border: 1px solid #000000;
     padding: 10px 0px 10px 5px; 
    }
.enroll-form-btn{
background: #FFA900;
width: 100%;
border: none;
border-radius: 10px;
padding: 10px;
}
@media only screen and (max-width: 600px){
    .form-box{
    box-shadow: 0px 4px 16px 0px #00000040;
    width: 100%;
    border-radius:10px;
    height: 100%;
    
    }
}
    `}
 </style>
 </>

)
}
